import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c33c206"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "crop-hint"
}
const _hoisted_3 = { class: "cropper-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("确认裁切")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Cropper = _resolveComponent("Cropper")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "crop-uploader",
      style: _normalizeStyle(_ctx.previewStyle),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
    }, [
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.modelValue,
            class: "crop-preview",
            style: _normalizeStyle(_ctx.previewStyle)
          }, null, 12, _hoisted_1))
        : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            class: "crop-placeholder",
            style: _normalizeStyle(_ctx.placeholderStyle)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Plus)
            ]),
            _: 1
          }, 8, ["style"]))
    ], 4),
    (_ctx.hint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.hint), 1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      ref: "fileInputRef",
      type: "file",
      accept: "image/*",
      style: {"display":"none"},
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
    }, null, 544),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "裁切图片",
      width: "600px",
      "close-on-click-modal": false,
      onOpened: _ctx.onDialogOpened
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onConfirmCrop
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Cropper, {
            ref: "cropperRef",
            src: _ctx.tempImageSrc,
            "stencil-props": _ctx.stencilProps,
            class: "cropper-area"
          }, null, 8, ["src", "stencil-props"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onOpened"])
  ]))
}